import { BaseAction } from "../base/base.action";

export class ProductAction extends BaseAction {
    constructor() {
        super("PRODUCT")
    }
}


